import { areaPath, type Area } from "@/routes/paths";

const AREA_KEY = (username: string) => `safers.last-area:${username}`;
const SITE_KEY = (username: string) => `safers.last-site:${username}`;

const AREAS: Area[] = ["control", "health", "cctv"];

function read(store: Storage, key: string): string | null {
  try {
    return store.getItem(key);
  } catch {
    return null;
  }
}

function write(store: Storage, key: string, value: string): void {
  try {
    store.setItem(key, value);
  } catch {
    return;
  }
}

function remove(store: Storage, key: string): void {
  try {
    store.removeItem(key);
  } catch {
    return;
  }
}

/**
 * 영역은 `localStorage`, 현장은 `sessionStorage` 다.
 *
 * 영역은 **다음 로그인까지 살아남아야** 하므로 탭이 닫히면 사라지는
 * `sessionStorage` 로는 안 된다. 대신 로그아웃에서 지워, 브라우저에 며칠 전 값이
 * 남는 상황을 막는다.
 *
 * 현장은 지금 규칙을 유지한다 — `localStorage` 로 바꾸면 탭마다 섞이고, 브라우저를
 * 닫아도 며칠 전 현장이 남는다.
 */
export function readLastArea(username: string | null): Area | null {
  if (!username) return null;
  const raw = read(localStorage, AREA_KEY(username));
  return AREAS.includes(raw as Area) ? (raw as Area) : null;
}

export function writeLastArea(username: string | null, area: Area): void {
  if (!username) return;
  write(localStorage, AREA_KEY(username), area);
}

export function readLastSite(username: string | null): string | null {
  if (!username) return null;
  return read(sessionStorage, SITE_KEY(username));
}

export function writeLastSite(username: string | null, siteId: string): void {
  if (!username) return;
  write(sessionStorage, SITE_KEY(username), siteId);
}

export function clearLastVisit(username: string | null): void {
  if (!username) return;
  remove(localStorage, AREA_KEY(username));
  remove(sessionStorage, SITE_KEY(username));
}

/** 로그인 직후 착지할 주소. 기억이 없으면 관제 전국. */
export function landingPath(username: string | null): string {
  const area = readLastArea(username);
  if (!area) return areaPath("control");
  const siteId = readLastSite(username);
  if (area === "cctv" && !siteId) return areaPath("control");
  return areaPath(area, siteId);
}
